import { Injectable } from '@angular/core';
import { AssetSummary } from '@imcc/transport';
import { Observable } from 'rxjs';
import { HttpClient } from '../../../lib/network/http-client';

@Injectable()
export class AssetSummaryRepository {
  constructor(private httpClient: HttpClient) {}

  current(): Observable<AssetSummary> {
    return this.httpClient.get<AssetSummary>('/asset-summaries');
  }
}
